import { http } from "../utils/http";

import config from "../config";
import endpoints from "../constants/endpoints";

let isFetchingAccessToken = false;
let refreshTokenPromiseCache = null;

export const login = (email, password) => {
  const loginPayload = {
    email,
    password,
  };
  const url = `${config.authBaseUrl}${endpoints.login}`;

  return http.post(url, loginPayload);
};

/**
 * Refresh Access Token using the API.
 *
 * @param {string} refreshToken
 *
 * @returns {Promise} A promise to a get request to get a new access token.
 */
export const refreshAccessToken = async (refreshToken) => {
  if (!isFetchingAccessToken) {
    isFetchingAccessToken = true;

    const url = `${config.authBaseUrl}${endpoints.refreshToken}`;

    refreshTokenPromiseCache = http
      .post(url, {
        refresh_token: refreshToken,
      })
      .then((response) => {
        isFetchingAccessToken = false;

        const newAccessToken = response?.data?.result?.["token"];
        const newRefreshToken = response?.data?.result?.["refresh-token"];

        return { newAccessToken, newRefreshToken };
      })
      .catch((error) => {
        isFetchingAccessToken = false;

        throw error;
      });
  }

  return refreshTokenPromiseCache;
};
